import React from "react";
import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, y = 28, className = "", once = true }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount: 0.25 }}
      transition={{ duration: 0.95, delay, ease: [0.16, 1, 0.3, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function SectionEyebrow({ children }) {
  return (
    <div className="flex items-center gap-3 text-[11px] tracking-luxury uppercase text-bronze-deep">
      <span className="w-10 h-px bg-bronze/60" />
      <span className="font-medium">{children}</span>
    </div>
  );
}

export function SectionTitle({ eyebrow, title, subtitle, align = "left", dark = false }) {
  return (
    <div className={align === "center" ? "text-center" : ""}>
      {eyebrow && (
        <div className={align === "center" ? "flex justify-center" : ""}>
          <SectionEyebrow>{eyebrow}</SectionEyebrow>
        </div>
      )}
      <h2
        className={`font-display text-[2.2rem] sm:text-4xl lg:text-[3rem] ${dark ? "text-cream" : "text-forest-deep"} leading-[1.1] mt-5 tracking-[-0.025em]`}
        style={{ fontWeight: 200 }}
        dangerouslySetInnerHTML={{ __html: title }}
      />
      {subtitle && (
        <p className={`mt-6 ${dark ? "text-cream/70" : "text-ink-soft/70"} font-light text-base sm:text-lg max-w-2xl leading-relaxed ${align === "center" ? "mx-auto" : ""}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
}
